import styled, { css } from 'styled-components';

import {
  Avatar,
  Typography,
  Button,
} from '@mui/material';

import colors from '../../../../../../styles/colors';

const avatarCircleSizePx = 60;
const marginPx = 30;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 30px;
  background-color: ${colors.base.alpha};
`;

const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: ${marginPx}px;
  gap: 12px;
`;

const StyledAvatar = styled(Avatar)`
  height: ${avatarCircleSizePx}px;
  width: ${avatarCircleSizePx}px;
  position: relative;
`;

const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`;

const UserInfoTitle = styled(Typography)`
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 26px;
  margin: 0 10px;
  color: ${colors.base.secondary2};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
`;

const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  column-gap: 20px;
  margin-bottom: ${marginPx}px;
`;

const ContentContainer = styled.div`
  background: ${colors.base.alpha};
  padding: 0px;
  display: flex;
  flex-direction: row;
  column-gap: 25px;
  width: 100%;
  align-items: center;
`;

const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`;

const Label = styled.div`
  font-size: 8px;
  font-weight: 500;
  line-height: 9px;
  letter-spacing: 0.07em;
  ${({ $isAllergens }) => $isAllergens && css`
    color: ${colors.shades.danger5};
  `}
`;

const buttonStyles = css`
  background-color: ${colors.shades.secondary4};
  border-radius: 36px;
  color: ${colors.base.secondary2};
  font-size: 14px;
  padding: 8px 16px;
  font-weight: 400;
  text-transform: none;
  border: 1px solid ${colors.shades.secondary4};
  &:hover {
    background-color: ${colors.shades.secondary5};
    border: 1px solid ${colors.shades.secondary4};
    cursor: pointer;
  }
`;

const FeedbackButton = styled(Button)`
  ${buttonStyles};
`;

export {
  Container,
  StyledAvatar,
  UserInfoContainer,
  UserInfoTitle,
  TitleRow,
  SectionContainer,
  FeedbackButton,
  ItemContainer,
  Label,
  ContentContainer,
};
